import React, { useEffect, useState } from "react"
import { initialCustomerPartQueryParams, usePartChemicals } from "@ncs/ncs-api"
import { arrayWrap } from "@ncs/ts-utils"
import { Box, SelectEcomm, useUrlState, TrackingEvent } from "@ncs/web-legos"
import { PartSearchResultsUrlState } from "../PartSearchResults"
import { useAnalytics } from "~/hooks/useAnalytics"
import { css } from "@emotion/react"

const ACCESORIES_CATEGORY = "Accessories"

const sortOptions = [
	{ value: "title", text: "Name A - Z" },
	{ value: "-title", text: "Name  Z - A" },
	{ value: "price", text: "Price low to high" },
	{ value: "-price", text: "Price high to low" },
	{ value: "-visit_count", text: "Popular" },
	{ value: "online_part_number", text: "Product number" },
]

type PartSortUrlState = Pick<
	PartSearchResultsUrlState,
	"ordering" | "page" | "categories" | "brands" | "chemicals"
>

export const PartSortEcomm: React.FC = React.memo(() => {
	const [defaultOrderBy, setDefaultOrderBy] = useState("title")
	const [{ ordering, categories, chemicals, brands }, { setUrlState }] =
		useUrlState<PartSortUrlState>({
			ordering: initialCustomerPartQueryParams.ordering,
			categories: initialCustomerPartQueryParams.categories,
			chemicals: initialCustomerPartQueryParams.chemicals,
			brands: initialCustomerPartQueryParams.brands,
		})
	const [chemicalCategories] = usePartChemicals()
	const { trackEvent } = useAnalytics()

	useEffect(() => {
		if (!ordering) {
			const hasCategories = arrayWrap(categories).length > 0
			const hasChemicals = arrayWrap(chemicals).length > 0
			const hasBrands = arrayWrap(brands).length > 0
			const accesoriesId = chemicalCategories?.find(
				(c) => c.name === ACCESORIES_CATEGORY
			)?.id
			const haveJustAccesories =
				hasChemicals && !arrayWrap(chemicals)?.some((c: any) => c !== accesoriesId)

			if (
				hasCategories ||
				haveJustAccesories ||
				(hasBrands && (!hasChemicals || haveJustAccesories))
			) {
				setDefaultOrderBy("-visit_count")
			} else {
				setDefaultOrderBy("title")
			}
		}
	}, [brands, categories, ordering, chemicals, chemicalCategories])

	const sortByHandler = (newValue: string | null) => {
		setUrlState((prev) => ({ ...prev, ordering: newValue, page: 1 }))
		trackEvent(TrackingEvent.SORT_BY_LIST)
		trackEvent(TrackingEvent.SORT_BY_OPTION, { option: newValue })
	}

	return (
		<Box display="flex" flexShrink={0} alignItems="center" ml={1}>
			<label htmlFor="sort-by" css={sortLabel}>
				Sort by:{" "}
			</label>

			<SelectEcomm
				options={sortOptions}
				value={ordering ?? defaultOrderBy}
				showNoSelectionOption={false}
				onChange={sortByHandler}
				mb={0}
				selectId="sort-by"
			/>
		</Box>
	)
})

const sortLabel = css`
	margin-right: 0.75rem;
	font-weight: 500;
	font-size: 0.875rem;
`
